import type { ReactNode } from 'react';

/** Estrutura padrão de uma página: título, descrição, ações à direita e o conteúdo. */

export interface PageLayoutProps {
  /** Título da página (h1). */
  title: ReactNode;
  /** Texto secundário abaixo do título. */
  description?: ReactNode;
  /** Ações do cabeçalho (botões à direita). */
  actions?: ReactNode;
  /** Conteúdo auxiliar ao lado do título (contadores, selos). */
  counter?: ReactNode;
  /** Informação ao lado do título. */
  info?: ReactNode;
  /** Conteúdo da página. */
  children: ReactNode;
}

export function PageLayout({ title, description, actions, counter, info, children }: PageLayoutProps) {
  return (
    <div className="px-4 pb-8 pt-7 md:px-10">
      <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0 flex-1 basis-full md:basis-auto">
          <div className="flex items-center gap-2">
            <h1 className="text-2xl font-semibold text-kumo-default">{title}</h1>
            {counter ? <span className="text-kumo-subtle">{counter}</span> : null}
            {info}
          </div>
          {description ? <p className="mt-1 max-w-3xl text-kumo-subtle">{description}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
      </div>
      {children}
    </div>
  );
}
